console.log('Custom script loaded');
if(!customElements.get('super-slider')) {
    class SuperSlider extends HTMLElement {
        constructor() {
            super();
            this.config = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
            new Swiper(this, this.config);
        }
    }
    
    customElements.define('super-slider', SuperSlider);
}